import { Map } from 'immutable';

/* eslint-disable quote-props */
export const newWineTypes = Map({
  Red: false,
  White: false,
  Sparkling: false,
  Rosé: false,
});

export const filterStateData = Map({
  isDataLoading: false,
  filtersApplied: false,
  filterSelection: '',
  category: 'wine',
  resetState: false,
  sortSelection: 'bestSellers',
  relayFilterVariables: Map({
    sortBy: 'bestSellers',
    filterPrice: ['any'],
    filterByVarietal: ['any'],
    filterByCause: ['any'],
    filterByType: ['any'],
    filterByGiftCategories: ['any'],
  }),
  customPCPVariables: Map({
    productCategories: ['any'],
    productsExclude: null,
    productsOnly: null,
  }),
  wineTypes: Map({
    Red: false,
    White: false,
    Sparkling: false,
    Rosé: false,
  }),
  wineVarietals: Map({
    Chardonnay: false,
    Dessert: false,
    Merlot: false,
    Riesling: false,
    Syrah: false,
    Zinfandel: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    'Cabernet Sauvignon': false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    'Pinot Noir': false,
    'Red Blend': false,
  }),
  causes: Map({
    Animals: false,
    Children: false,
    Environment: false,
    Education: false,
    Global: false,
    Health: false,
    Veterans: false,
    Women: false,
  }),
  categoryStates: Map({
    Animals: false,
    Children: false,
    Environment: false,
    Education: false,
    Global: false,
    Health: false,
    Veterans: false,
    Women: false,
    Red: false,
    White: false,
    Sparkling: false,
    Chardonnay: false,
    Dessert: false,
    Merlot: false,
    Riesling: false,
    Syrah: false,
    Zinfandel: false,
    Rosé: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    'Cabernet Sauvignon': false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    'Pinot Noir': false,
    'Red Blend': false,
    'Under $20': false,
    '$20—$40': false,
    '$40—$60': false,
    '$60—$80': false,
    '$80—$100': false,
    'Over $100': false,
    'Wine Sets': false,
    'Gifts for Her': false,
    'Gifts for Him': false,
    'Special Occasions': false,
    Seasonal: false,
    Pets: false,
    'No Alcohol': false,
  }),
  giftCategories: Map({
    'Wine Sets': false,
    'Gifts for Her': false,
    'Gifts for Him': false,
    'Special Occasions': false,
    Seasonal: false,
    Pets: false,
    'No Alcohol': false,
  }),
  prices: Map({
    'Under $20': false,
    '$20—$40': false,
    '$40—$60': false,
    '$60—$80': false,
    '$80—$100': false,
    'Over $100': false,
  }),
  disabledVarietals: Map({
    Chardonnay: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    Riesling: false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    Dessert: false,
    Merlot: false,
    Syrah: false,
    Zinfandel: false,
    'Cabernet Sauvignon': false,
    'Pinot Noir': false,
    'Red Blend': false,
  }),
});

export const resetAllGiftCategories = Map({
  'Wine Sets': false,
  'Gifts for Her': false,
  'Gifts for Him': false,
  'Special Occasions': false,
  Seasonal: false,
  Pets: false,
  'No Alcohol': false,
});

export const resetDisabledVarietals = Map({
  Chardonnay: false,
  'Fumé Blanc': false,
  'Sauvignon Blanc': false,
  Riesling: false,
  'Muscat Canelli': false,
  'Pinot Grigio': false,
  Dessert: false,
  Merlot: false,
  Syrah: false,
  Zinfandel: false,
  'Cabernet Sauvignon': false,
  'Pinot Noir': false,
  'Red Blend': false,
});

export const setDisabledWhiteVarietals = Map({
  Chardonnay: true,
  'Fumé Blanc': true,
  'Sauvignon Blanc': true,
  Riesling: true,
  'Muscat Canelli': true,
  'Pinot Grigio': true,
  Dessert: false,
  Merlot: false,
  Syrah: false,
  Zinfandel: false,
  'Cabernet Sauvignon': false,
  'Pinot Noir': false,
  'Red Blend': false,
});

export const setDisabledRedVarietals = Map({
  Chardonnay: false,
  'Fumé Blanc': false,
  'Sauvignon Blanc': false,
  Riesling: false,
  'Muscat Canelli': false,
  'Pinot Grigio': false,
  Dessert: true,
  Merlot: true,
  Syrah: true,
  Zinfandel: true,
  'Cabernet Sauvignon': true,
  'Pinot Noir': true,
  'Red Blend': true,
});

export const resetCategoryStates = Map({
  Animals: false,
  Children: false,
  Environment: false,
  Education: false,
  Global: false,
  Health: false,
  Veterans: false,
  Women: false,
  Red: false,
  White: false,
  Sparkling: false,
  Chardonnay: false,
  Dessert: false,
  Merlot: false,
  Riesling: false,
  Syrah: false,
  Zinfandel: false,
  Rosé: false,
  'Fumé Blanc': false,
  'Sauvignon Blanc': false,
  'Cabernet Sauvignon': false,
  'Muscat Canelli': false,
  'Pinot Grigio': false,
  'Pinot Noir': false,
  'Red Blend': false,
  'Under $20': false,
  '$20—$40': false,
  '$40—$60': false,
  '$60—$80': false,
  '$80—$100': false,
  'Over $100': false,
  'Wine Sets': false,
  'Gifts for Her': false,
  'Gifts for Him': false,
  'Special Occasions': false,
  Seasonal: false,
  Pets: false,
  'No Alcohol': false,
});

export const resetWineTypes = Map({
  Red: false,
  White: false,
  Sparkling: false,
  Rosé: false,
});

export const resetWineVarietals = Map({
  Chardonnay: false,
  Dessert: false,
  Merlot: false,
  Riesling: false,
  Syrah: false,
  Zinfandel: false,
  'Fumé Blanc': false,
  'Sauvignon Blanc': false,
  'Cabernet Sauvignon': false,
  'Muscat Canelli': false,
  'Pinot Grigio': false,
  'Pinot Noir': false,
  'Red Blend': false,
});

export const resetCauses = Map({
  Animals: false,
  Children: false,
  Environment: false,
  Education: false,
  Global: false,
  Health: false,
  Veterans: false,
  Women: false,
});
